import { Component, Input,SimpleChanges, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { IProjectSearchResult } from '../../../projects/shared/models/project-search-result';
import { ITableColumn, TableColumnType } from '../../../controls/table/table-column';
import { ITableFilter } from '../../../controls/table/table-filter';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-committee-details-project',
    templateUrl: './committee-details-project.component.html',
    styleUrl: './committee-details-project.component.scss',
    standalone: false
})

export class CommitteeDetailsProjectComponent implements OnInit, OnDestroy, OnChanges {

  @Input() projects: IProjectSearchResult[] | null = null;
  @Input() loading: boolean = true;
  subscriptions: Subscription = new Subscription();

  tableData: IProjectSearchResult[] = [];
  tableColumns: ITableColumn<IProjectSearchResult>[] = [];
  tableFilters: ITableFilter[] = [];


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.initializeTableColumns();
    this.initializeTableData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['projects'] && changes['projects'].currentValue && !changes['projects'].firstChange) {
      this.projects = changes['projects'].currentValue;
      this.initializeTableData();
    }
  }


  initializeTableData() {
    if(this.projects){
      this.tableData = this.projects;
    } else {
      this.tableData = [];
    }

  }

  initializeTableColumns() {
    let columns = [
      {
        name: 'designation',
        displayName: 'Designation',
        type: TableColumnType.routerLink,
        isSortable: true,
        getLink: (row: IProjectSearchResult) => `/projects/${row.projectId}`,
        headerWidth: '250px'
      },
      {
        name: 'projectTitle',
        displayName: 'Project Title',
        isSortable: true,
        headerWidth: '35%'
      },
      {
        name: 'phase',
        displayName: 'Phase',
        isSortable: true
      },
      {
        name: 'phaseStart',
        displayName: 'Phase Start',
        type: TableColumnType.date,
        isSortable: true,
      },
      {
        name: 'phaseEnd',
        displayName: 'Phase End',
        type: TableColumnType.date,
        isSortable: true,
      },
      {
        name: 'status',
        displayName: 'Project Status',
        isSortable: true
      }
    ]
    this.tableColumns = columns;
  }

}
